import { MAX_AUTH_REDIRECTS } from "./constants";

/**
 * Counts Auth0 `?code=` callback landings in a session.
 * Hitting maxRedirects means we are in a login loop (Auth0 ↔ app bouncing).
 */
export function registerAuthCodeCallback(input: { search: string; currentCount: number; maxRedirects?: number }): {
  counted: boolean;
  nextCount: number;
  isLoginLoop: boolean;
} {
  const maxRedirects = input.maxRedirects ?? MAX_AUTH_REDIRECTS;
  const params = new URLSearchParams(input.search.startsWith("?") ? input.search.slice(1) : input.search);

  // `state` is required alongside `code` so we match auth0-react's own definition
  // of a callback (hasAuthParams). A stray `code` on any other link is not one.
  if (!params.get("code") || !params.get("state")) {
    return { counted: false, nextCount: input.currentCount, isLoginLoop: false };
  }

  const nextCount = input.currentCount + 1;
  return {
    counted: true,
    nextCount,
    isLoginLoop: nextCount >= maxRedirects,
  };
}
